import produce from 'immer';

export const initialState = {
    forceUpdate: false,
};

const actions = {
    FIELD: 'FIELD',
    RESET: 'RESET',
    OVERRIDE: 'OVERRIDE',
};

export function reducer(state = initialState, action: any) {
    switch (action.type) {
        case actions.FIELD:
            return produce(state, (draftState: { [x: string]: any }) => {
                draftState[action.field] = action.value;
            });
        case actions.OVERRIDE:
            return produce(state, () => {
                return action.value;
            });
        case actions.RESET:
            return produce(state, () => {
                return initialState;
            });
        default:
            return state;
    }
}
